// Generated by purs version 0.11.7
"use strict";
var $foreign = require("./foreign");
var Data_Show = require("../Data.Show");
var showUnit = new Data_Show.Show(function (v) {
    return "unit";
});
module.exports = {
    showUnit: showUnit,
    unit: $foreign.unit
};



//////////////////
// WEBPACK FOOTER
// ./output/Data.Unit/index.js
// module id = 15
// module chunks = 0